import { useState } from "react";
import { Outlet } from "react-router-dom";
import { MarketingFooter } from "@/components/marketing/MarketingFooter";
import { AdminHeader } from "./AdminHeader";
import { AdminSidebar } from "./AdminSidebar";
import { Sheet, SheetContent } from "@/components/ui/sheet";
import { SessionTimeoutWarning } from "@/components/auth/SessionTimeoutWarning";
import { useActivityTimeout } from "@/hooks/useActivityTimeout";
import { useAuth } from "@/contexts/AuthContext";

export function AdminLayout() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { signOut, isAuthenticated } = useAuth();
  
  // Check if user selected "Remember me"
  const isRemembered = localStorage.getItem('podgo_remember_me') === 'true';
  
  const { showWarning, timeRemaining, extendSession } = useActivityTimeout({
    timeoutMinutes: isRemembered ? 10080 : 240, // 7 days or 4 hours
    warningMinutes: 5,
    onTimeout: () => signOut(),
    enabled: isAuthenticated,
  });

  return (
    <div className="min-h-screen bg-background">
      {/* Desktop Sidebar - Hidden on mobile/tablet */}
      <aside className="fixed inset-y-0 left-0 z-30 hidden w-64 border-r border-border desktop:block">
        <AdminSidebar />
      </aside>

      {/* Mobile/Tablet Drawer */}
      <Sheet open={isMobileMenuOpen} onOpenChange={setIsMobileMenuOpen}>
        <SheetContent side="left" className="w-64 p-0 bg-sidebar">
          <AdminSidebar 
            onNavigate={() => setIsMobileMenuOpen(false)}
            showCloseButton
            onClose={() => setIsMobileMenuOpen(false)}
          />
        </SheetContent>
      </Sheet>

      {/* Main Content Area */}
      <div className="desktop:pl-64">
        <AdminHeader onMenuClick={() => setIsMobileMenuOpen(true)} />
        
        {/* Page Content */}
        <main className="p-4 tablet:p-6 desktop:p-8">
          <Outlet />
        </main>

        {/* Footer */}
        <MarketingFooter />
      </div>

      {/* Session Timeout Warning Modal */}
      <SessionTimeoutWarning
        open={showWarning}
        timeRemaining={timeRemaining}
        onExtend={extendSession}
        onLogout={signOut}
      />
    </div>
  );
}
